import { render, staticRenderFns } from "./UserEditFormSubmit.vue?vue&type=template&id=cbbb8a0c&"
import script from "./UserEditFormSubmit.vue?vue&type=script&lang=ts&"
export * from "./UserEditFormSubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports